<!-- Таблица переопределения исходных значений для новой версии ПЛАНа. -->
<template>
  <div class="plan-inputs">
    <div class="plan-inputs__header">
      <span>Показатель</span>
      <span>Исходное значение</span>
      <span>Для расчёта</span>
      <span></span>
    </div>

    <PlanCalculationNormRow
      v-for="row in rows"
      :key="row.code"
      :row="row"
      :value="draft[row.code]"
      :changed="differs(row)"
      :editable="editable"
      @update-value="updateValue(row.code, $event)"
      @restore="$emit('restore', row)"
    />

    <PlanCalculationNormActions
      v-if="editable"
      :next-version="nextVersion"
      :invalid="invalid"
      :is-calculating="isCalculating"
      :changed-count="changedCount"
      :result-name="resultName"
      @reset="$emit('reset-all')"
      @recalculate="$emit('recalculate')"
    />
  </div>
</template>

<script>
import PlanCalculationNormActions from "@/components/Order/PlanCalculation/NormActions.vue";
import PlanCalculationNormRow from "@/components/Order/PlanCalculation/NormRow.vue";
import { isPlanParameterDifferent } from "@/utils/orderCalculation/overrideUtils";

export default {
  name: "OrderPlanCalculationInputsEditor",

  components: {
    PlanCalculationNormActions,
    PlanCalculationNormRow,
  },

  props: {
    rows: { type: Array, default: () => [] },
    draft: { type: Object, default: () => ({}) },
    nextVersion: { type: Number, required: true },
    invalid: { type: Boolean, default: false },
    isCalculating: { type: Boolean, default: false },
    changedCount: { type: Number, default: 0 },
    resultName: { type: String, default: "Результат" },
    editable: { type: Boolean, default: false },
  },

  emits: ["update-value", "restore", "reset-all", "recalculate"],

  methods: {
    differs(row) {
      return isPlanParameterDifferent(this.draft[row.code], row.originalValue);
    },
    updateValue(code, value) {
      this.$emit("update-value", { code, value });
    },
  },
};
</script>

<style scoped>
.plan-inputs__header {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 110px 130px 36px;
  gap: 10px;
  align-items: center;
  padding: 0 14px;
}

.plan-inputs__header {
  height: 30px;
  color: #5b6070;
  font-size: 12px;
}

.plan-inputs__header > :nth-child(2),
.plan-inputs__header > :nth-child(3) {
  text-align: right;
}

@media (max-width: 768px) {
  .plan-inputs__header {
    display: none;
  }
}
</style>
